exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".artistContainer {\n  margin-top: 70px; }\n  .artistContainer .mainHeader {\n    height: 500px;\n    background: url(" + require("./../../../assets/images/static/band.jpeg") + ");\n    background-size: cover;\n    background-position: top center; }\n  .artistContainer .article {\n    margin-top: -300px;\n    padding: 30px;\n    min-height: 500px; }\n    .artistContainer .article .regularLink {\n      text-decoration: none;\n      color: #007bd9;\n      font-weight: bold;\n      display: flex;\n      line-height: 22px; }\n    .artistContainer .article .regularLinkB {\n      text-decoration: none;\n      color: #007bd9;\n      font-weight: bold;\n      line-height: 22px; }\n\n@media only screen and (max-width: 1024px) {\n  .addTabContainer {\n    margin-top: 70px; }\n    .addTabContainer .mainHeader {\n      height: 400px; } }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/lib/loader.js?{"includePaths":["/var/www/www.taburi.ro/releases/98/src"]}!./src/components/artist/css/index.scss
// module id = 513
// module chunks = 0